import { CSSProperties, FC } from 'react';

import styles from './ProgressBar.module.scss';

type ProgressBarProps = {
  percentage: number
}

export const ProgressBar: FC<ProgressBarProps> = ({ percentage }) => {
  return (
    <div
      className={styles.container}
      role="progressbar"
      aria-valuenow={percentage}
      aria-valuemin={0}
      aria-valuemax={100}
      style={{ '--progress': `${percentage}%` } as CSSProperties}
    >
      <div className={styles.progress} />
    </div>
  );
};

export default ProgressBar;
